import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function Privacy() {
  return (
    <div className="legal-page" data-testid="privacy-page">
      <motion.div
        className="legal-container"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
      >
        <a className="back-link" href="/" data-testid="back-link">
          Back
        </a>

        <h1 className="legal-title" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <p className="legal-updated">Last updated: August 18, 2026</p>

        <div className="legal-body">
          <p>
            Impression Profit LLC ("we," "us," or "our") operates the website readyforthecheck.com
            (the "Site"), doing business as Ready for the Check. This Privacy Policy explains how we
            collect, use, disclose, and safeguard your information when you visit our Site.
          </p>

          <h2>Information We Collect</h2>
          <h3 className="legal-sub">Information You Provide</h3>
          <p>When you join our waitlist, you voluntarily provide:</p>
          <ul>
            <li>First and last name</li>
            <li>Email address</li>
            <li>City or region</li>
            <li>Age</li>
            <li>Occupation</li>
            <li>Whether you're joining as a dater, a matchmaker, or in another capacity</li>
          </ul>
          <h3 className="legal-sub">Information Collected Automatically</h3>
          <p>
            We do not currently use analytics, advertising pixels, or tracking cookies on this Site.
            If that changes in the future, we will update this section before any such tool is added
            — not after.
          </p>
          <h3 className="legal-sub">Cookies and Tracking Technologies</h3>
          <p>
            We do not currently use cookies or similar tracking technologies beyond what's strictly
            necessary for the waitlist form to function (for example, preventing duplicate
            submissions). We do not use cookies for advertising or cross-site tracking.
          </p>

          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Notify you when Ready for the Check launches</li>
            <li>
              Understand who's interested in the product before we build it further (for example,
              whether early interest is mostly individuals, matchmakers, or platforms)
            </li>
            <li>Respond to your inquiries if you contact us directly</li>
            <li>Comply with legal obligations, if any arise</li>
          </ul>
          <p>We do not use your information for advertising, and we do not sell it.</p>

          <h2>Third-Party Services</h2>
          <p>
            We share your information with the following third-party service providers, solely to
            operate the waitlist:
          </p>
          <ul>
            <li>
              Google Sheets, where a working copy of waitlist signups is stored for our internal
              use, under Google's own privacy and security terms
            </li>
            <li>
              Our website hosting and backend infrastructure provider, which stores your information
              in our application database
            </li>
          </ul>
          <p>
            We do not share your information with any other third party, and we do not permit these
            providers to use your information for their own purposes.
          </p>

          <h2>Data Retention</h2>
          <p>
            We retain your information for as long as you remain on our waitlist, or until you
            request deletion, whichever comes first.
          </p>

          <h2>Your Rights</h2>
          <p>You may have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction or deletion of your personal information</li>
            <li>Request a copy of your data in a portable format</li>
            <li>Withdraw consent, since your information was provided to us on that basis</li>
          </ul>
          <p>
            To exercise any of these rights, contact us at the address below. If you're located
            somewhere with specific statutory data protection rights (such as the EU/UK under GDPR,
            or California under the CCPA), those rights apply to you in full through the same
            contact.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            You must be 18 or older to join this waitlist, and our form enforces this at signup. We
            do not knowingly collect information from anyone under 18. If we learn that we have, we
            will delete it promptly.
          </p>

          <h2>Security</h2>
          <p>
            We implement reasonable administrative, technical, and physical security measures to
            protect your information. No method of transmission over the internet or electronic
            storage is completely secure, and we cannot guarantee absolute security.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            As we build the full Ready for the Check product, we will collect additional information
            as part of identity and background verification — that future functionality will be
            covered by an updated version of this policy before it launches, not folded in quietly.
            We will post the new "Last updated" date whenever this policy changes, and notify
            waitlist members directly by email of any material change.
          </p>

          <h2>Contact Us</h2>
          <p>Questions about this policy or your data:</p>
          <p>
            Impression Profit LLC dba Ready for the Check
            <br />
            Email:{" "}
            <a href="mailto:readyforthecheck@freddymedia.com" data-testid="privacy-contact-email">
              readyforthecheck@freddymedia.com
            </a>
          </p>
        </div>
      </motion.div>
    </div>
  );
}
